export const styles = {
  container:
    "max-w-7xl mx-auto text-gray-800 dark:text-gray-100 font-lato text-sm font-normal",
  mainContainer:
    "bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md border border-gray-200 dark:border-gray-700",
  header: "flex items-center px-0 py-1 justify-between",
  title: "text-xl font-semibold text-gray-800 dark:text-white/90 text-center",
  buttonGroup: "flex items-center gap-2",
  downloadButton:
    "w-8 h-8 bg-[#d2a81b] dark:bg-[#d4b035] flex items-center justify-center rounded-md shadow hover:bg-[#e7ba1f] dark:hover:bg-[#ffaf33] transition disabled:opacity-60 disabled:cursor-not-allowed",
  emailButton:
    "w-8 h-8 bg-[#167968] dark:bg-[#20ac95] flex items-center justify-center rounded-md shadow hover:bg-[#20ac95] dark:hover:bg-[#167968] transition disabled:opacity-60 disabled:cursor-not-allowed",
  backButton:
    "px-3 py-1.5 bg-[#2f6aa7] dark:bg-[#3d6794] hover:bg-[#2779bd] dark:hover:bg-[#335877] text-sm text-white dark:text-gray-300 rounded-lg flex items-center",
  detailsContainer:
    "mt-6 bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-100 border border-gray-300 dark:border-gray-700 shadow-sm p-4 rounded-xl transition-colors duration-300",
  section: "space-y-6",
  fromToGrid: "grid grid-cols-1 sm:grid-cols-2 gap-6 border-b border-gray-200 dark:border-gray-700 pb-4",
  fromToTitle: "text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2",
  fromToValue: "text-sm font-medium text-gray-900 dark:text-gray-100",
  infoText: "text-sm text-gray-500 dark:text-gray-400",
  infoValue: "text-theme-sm font-medium text-gray-900 dark:text-gray-100",
  infoGrid: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4",
  termsText: "text-sm text-gray-500 dark:text-gray-400",
  termsValue: "text-theme-sm font-medium text-gray-900 dark:text-gray-100 text-justify",
  tableContainer: "mt-4",
  tableTitle: "text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3",
  tableWrapper: "overflow-x-auto border border-gray-200 dark:border-gray-700 rounded-lg",
  table: "w-full text-sm text-left text-gray-700 dark:text-gray-300",
  tableHead: "text-sm bg-gray-100 dark:bg-gray-900 text-gray-500 dark:text-gray-400",
  tableHeadCell: "px-4 py-2",
  tableRow: "border-t text-theme-sm font-medium text-gray-900 dark:text-gray-100 border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800",
  tableCell: "px-4 py-2",
  descriptionRow: "border-t border-gray-200 dark:border-gray-700",
  descriptionCell: "px-4 py-2 font-semibold text-sm text-gray-500 dark:text-gray-400 text-justify",
  descriptionText: "font-normal text-theme-sm text-gray-900 dark:text-gray-100",
  noDataCell: "px-4 py-2 text-center text-gray-500 dark:text-gray-400",
  totalsContainer: "mt-4 text-right space-y-1",
  totalText: "text-sm text-gray-600 dark:text-gray-400",
  totalValue: "text-sm font-medium text-gray-900 dark:text-gray-100",
  groupTotal: "text-lg font-semibold text-gray-900 dark:text-gray-100",
  modalOverlay:
    "fixed inset-0 bg-black bg-opacity-60 dark:bg-opacity-80 flex items-center justify-center z-50 transition-opacity duration-300",
  modal: "w-[90%] max-w-[400px] bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-6 relative transform transition-all duration-300 ease-in-out",
  modalIconContainer: "flex justify-center mb-4",
  modalIcon: "w-14 h-14 flex items-center justify-center bg-green-100 text-green-600 rounded-full",
  modalTitle: "text-xl font-bold text-gray-800 dark:text-white mb-3 text-center",
  modalMessage: "text-gray-600 dark:text-gray-400 mb-6 text-center",
  modalButtonContainer: "flex justify-center",
  modalButton: "px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors duration-200",
};